import { appendTestableElementAttributes, TestId } from '@dreryk/react-components';

import { StyledDescriptionCell } from './DescriptionCell.styled';

type DescriptionCellProps = {
   readonly description: string;
   readonly testId: TestId;
};

export const DescriptionCell = (props: DescriptionCellProps): JSX.Element => {
   return (
      <StyledDescriptionCell {...appendTestableElementAttributes(props.testId)}>
         {props.description}
      </StyledDescriptionCell>
   );
};
